// import React from "react";
// import Slider from "react-slick";

// const PopularServices = () => {
// const rentalCars = [
//   {
//     img: "/images/fleet/dsire.jpg",
//     price: 12,
//     rating: 4.8,
//     title: "Maruti Suzuki Dzire",
//     transmission: "Manual",
//     distance: "Unlimited KM",
//     fuel: "Petrol / CNG",
//     feature1: "AC",
//     feature2: "Comfort Ride",
//     passengers: "4 Persons",
//   },
//   {
//     img: "/images/fleet/ertiga.jpg",
//     price: 15,
//     rating: 4.8,
//     title: "Maruti Suzuki Ertiga",
//     transmission: "Manual",
//     distance: "Unlimited KM",
//     fuel: "Petrol / CNG",
//     feature1: "AC",
//     feature2: "Spacious",
//     passengers: "6 Persons",
//   },
//   {
//     img: "/images/fleet/innova.jpg",
//     price: 17,
//     rating: 4.9,
//     title: "Toyota Innova",
//     transmission: "Manual",
//     distance: "Unlimited KM",
//     fuel: "Diesel",
//     feature1: "AC",
//     feature2: "Luxury",
//     passengers: "7 Persons",
//   },
//   {
//     img: "/images/fleet/innova-crysta.jpg",
//     price: 18,
//     rating: 5.0,
//     title: "Toyota Innova Crysta",
//     transmission: "Manual",
//     distance: "Unlimited KM",
//     fuel: "Diesel",
//     feature1: "AC",
//     feature2: "Premium",
//     passengers: "7 Persons",
//   },
//   {
//     img: "/images/fleet/aura.jpg",
//     price: 11,
//     rating: 4.7,
//     title: "Hyundai Aura",
//     transmission: "Manual",
//     distance: "Unlimited KM",
//     fuel: "Petrol / CNG",
//     feature1: "AC",
//     feature2: "Comfort",
//     passengers: "4 Persons",
//   },
//   {
//     img: "/images/fleet/etios.jpg",
//     price: 13,
//     rating: 4.6,
//     title: "Toyota Etios",
//     transmission: "Manual",
//     distance: "Unlimited KM",
//     fuel: "Diesel",
//     feature1: "AC",
//     feature2: "Comfort Ride",
//     passengers: "4 Persons",
//   },
//   {
//     img: "/images/fleet/kia.jpg",
//     price: 16,
//     rating: 4.8,
//     title: "Kia Carens",
//     transmission: "Manual",
//     distance: "Unlimited KM",
//     fuel: "Diesel",
//     feature1: "AC",
//     feature2: "Spacious",
//     passengers: "6 Persons",
//   },
//   {
//     img: "/images/fleet/tempo-trevellar.jpg",
//     price: 25,
//     rating: 4.9,
//     title: "Tempo Traveller",
//     transmission: "Manual",
//     distance: "Unlimited KM",
//     fuel: "Diesel",
//     feature1: "AC",
//     feature2: "Group Travel",
//     passengers: "12-17 Persons",
//   },
//   {
//     img: "/images/fleet/mini-bus.jpg",
//     price: 35,
//     rating: 4.8,
//     title: "Mini Bus",
//     transmission: "Manual",
//     distance: "Unlimited KM",
//     fuel: "Diesel",
//     feature1: "AC",
//     feature2: "Group Travel",
//     passengers: "20-25 Persons",
//   },
//   {
//     img: "/images/fleet/bus.jpg",
//     price: 50,
//     rating: 4.9,
//     title: "Luxury Bus",
//     transmission: "Manual",
//     distance: "Unlimited KM",
//     fuel: "Diesel",
//     feature1: "AC",
//     feature2: "Luxury Seats",
//     passengers: "40-50 Persons",
//   },

// ];

//   // Slider settings for automatic sliding
//   const sliderSettings = {
//     dots: false,
//     infinite: true,
//     speed: 1000,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000, // 3 seconds
//     responsive: [
//       { breakpoint: 1024, settings: { slidesToShow: 2 } },
//       { breakpoint: 768, settings: { slidesToShow: 1 } },
//     ],
//   };

//   return (
//     <section className="section popular-services">
//       <div className="container">
//         {/* Heading */}
//        <div className="section-heading" data-aos="fade-down">
//   <h2>Our Fleet – Omshree Cab</h2>
//   <p>
//     Comfortable cars for all your travel needs with Omshree Cab.
//   </p>
// </div>

//         <Slider {...sliderSettings}>
//           {rentalCars.map((car, index) => (
//             <div className="rental-car-item" key={index}>
//               <div className="listing-item mb-0">
//                 <div className="listing-img">
//                   {Array.isArray(car.img) ? (
//                     <Slider {...{ dots: true, arrows: false, autoplay: true, autoplaySpeed: 2000 }}>
//                       {car.img.map((src, idx) => (
//                         <div className="slide-images" key={idx}>
//                           <a href="listing-details.html">
//                             <img src={src} className="img-fluid" alt={car.title} />
//                           </a>
//                         </div>
//                       ))}
//                     </Slider>
//                   ) : (
//                     <a href="listing-details.html">
//                       <img src={car.img} className="img-fluid" alt={car.title} />
//                     </a>
//                   )}
//                   <div className="fav-item justify-content-end">
//                     <a href="javascript:void(0)" className="fav-icon">
//                       <i className="feather-heart"></i>
//                     </a>
//                   </div>
//                 </div>

//                 <div className="listing-content">
//                   <div className="listing-features">
//                     <div className="fav-item-rental">
//                       <div className="featured-text">${car.price}<span>/day</span></div>
//                     </div>
//                     <div className="list-rating">
//                       {Array.from({ length: 5 }).map((_, i) => (
//                         <i
//                           key={i}
//                           className={`fas fa-star ${i < Math.floor(car.rating) ? "filled" : ""}`}
//                         ></i>
//                       ))}
//                       <span>({car.rating})</span>
//                     </div>
//                     <h3 className="listing-title">
//                       <a href="listing-details.html">{car.title}</a>
//                     </h3>
//                   </div>

//                   <div className="listing-details-group">
//                     <ul>
                   
//                     </ul>
//                     <ul>
//                       <li>
//                         <span><img src="/img/icons/car-parts-04.svg" alt="Feature" /></span>
//                         <p>{car.feature1}</p>
//                       </li>
//                       <li>
//                         <span><img src="/img/icons/car-parts-07.svg" alt="AC" /></span>
//                         <p>{car.feature2}</p>
//                       </li>
//                       <li>
//                         <span><img src="/img/icons/car-parts-06.svg" alt="Passengers" /></span>
//                         <p>{car.passengers}</p>
//                       </li>
//                     </ul>
//                   </div>

//                   <div className="listing-button">
//                     <a href="/booking" className="btn btn-order">
//                       <span><i className="feather-calendar me-2"></i></span>
//                       Book Now
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </Slider>

      
//       </div>
//     </section>
//   );
// };

// export default PopularServices;












import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

const PopularServices = () => {

const rentalCars = [
{
img: "/images/fleet/dsire.jpg",
price: 12,
rating: 4.8,
title: "Maruti Suzuki Dzire",
feature1: "AC",
feature2: "Comfort Ride",
passengers: "4 Persons",
},
{
img: "/images/fleet/ertiga.jpg",
price: 15,
rating: 4.8,
title: "Maruti Suzuki Ertiga",
feature1: "AC",
feature2: "Spacious",
passengers: "6 Persons",
},
{
img: "/images/fleet/innova.jpg",
price: 17,
rating: 4.9,
title: "Toyota Innova",
feature1: "AC",
feature2: "Luxury",
passengers: "7 Persons",
},
{
img: "/images/fleet/innova-crysta.jpg",
price: 18,
rating: 5.0,
title: "Toyota Innova Crysta",
feature1: "AC",
feature2: "Premium",
passengers: "7 Persons",
},
{
img: "/images/fleet/aura.jpg",
price: 11,
rating: 4.7,
title: "Hyundai Aura",
feature1: "AC",
feature2: "Comfort",
passengers: "4 Persons",
},
{
img: "/images/fleet/etios.jpg",
price: 13,
rating: 4.6,
title: "Toyota Etios",
feature1: "AC",
feature2: "Comfort Ride",
passengers: "4 Persons",
},
{
img: "/images/fleet/kia.jpg",
price: 16,
rating: 4.8,
title: "Kia Carens",
feature1: "AC",
feature2: "Spacious",
passengers: "6 Persons",
},
{
img: "/images/fleet/tempo-trevellar.jpg",
price: 25,
rating: 4.9,
title: "Tempo Traveller",
feature1: "AC",
feature2: "Group Travel",
passengers: "12-17 Persons",
},
{
img: "/images/fleet/mini-bus.jpg",
price: 35,
rating: 4.8,
title: "Mini Bus",
feature1: "AC",
feature2: "Group Travel",
passengers: "20-25 Persons",
},
{
img: "/images/fleet/bus.jpg",
price: 50,
rating: 4.9,
title: "Luxury Bus",
feature1: "AC",
feature2: "Luxury Seats",
passengers: "40-50 Persons",
}
];

return (
<section className="section popular-services">
<div className="container">

<div className="section-heading text-center mb-4">
<h2>Our Fleet – Omshree Cab</h2>
<p>Comfortable cars for all your travel needs with Omshree Cab.</p>
</div>

<Swiper
modules={[Autoplay]}
spaceBetween={20}
slidesPerView={1}
loop={true}
autoplay={{ delay: 3000 }}
breakpoints={{
768: {
slidesPerView: 2,
},
1024: {
slidesPerView: 3,
},
}}
>

{rentalCars.map((car, index) => (

<SwiperSlide key={index}>

<div className="listing-item">

<div className="listing-img">
<img src={car.img} className="img-fluid" alt={car.title} />
</div>

<div className="listing-content">

{/* <div className="featured-text">
${car.price}<span>/day</span>
</div> */}

{/* Rating */}
<div className="list-rating">
{Array.from({ length: 5 }).map((_, i) => (
<i
key={i}
className={`fas fa-star text-warning ${i < Math.floor(car.rating) ? "filled" : ""}`}
></i>
))}
<span >({car.rating})</span>
</div>

<h3 className="listing-title">
{car.title}
</h3>

<div className="listing-details-group">
<ul>

<li>
<span>
<img src="/img/icons/car-parts-04.svg" alt="AC"/>
</span>
<p>{car.feature1}</p>
</li>

<li>
<span>
<img src="/img/icons/car-parts-07.svg" alt="Feature"/>
</span>
<p>{car.feature2}</p>
</li>

<li>
<span>
<img src="/img/icons/car-parts-06.svg" alt="Passengers"/>
</span>
<p>{car.passengers}</p>
</li>

</ul>
</div>

<div className="listing-button">
<a href="/booking" className="btn btn-order">
<i className="feather-calendar me-2"></i>
Book Now
</a>
</div>

</div>
</div>

</SwiperSlide>

))}

</Swiper>

</div>
</section>
);
};

export default PopularServices;